import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
export default class UploadPollImageButton extends Button {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "uploadedImageUrl", false);
    _defineProperty(this, "fileName", undefined);
    _defineProperty(this, "$input", void 0);
  }
  view(vnode) {
    this.attrs.loading = this.loading;
    this.attrs.className = classList(this.attrs.className, 'Button');
    const imageUrl = this.getImageUrl();
    if (imageUrl) {
      this.attrs.onclick = this.remove.bind(this);
      return m("div", null, m("p", null, m("img", {
        src: imageUrl,
        alt: ""
      })), m("p", null, super.view(_objectSpread(_objectSpread({}, vnode), {}, {
        children: app.translator.trans('fof-polls.forum.upload_image.remove_button')
      }))));
    } else {
      this.attrs.onclick = this.upload.bind(this);
    }
    return super.view(_objectSpread(_objectSpread({}, vnode), {}, {
      poll: undefined,
      children: app.translator.trans('fof-polls.forum.upload_image.upload_button')
    }));
  }

  /**
   * Prompt the user to upload an image.
   */
  upload() {
    if (this.loading) return;
    this.$input = $('<input type="file">');
    this.$input.appendTo('body').hide().trigger('click').on('change', e => {
      const body = new FormData();
      // @ts-expect-error
      body.append(this.attrs.name, $(e.target)[0].files[0]);
      this.loading = true;
      m.redraw();
      app.request({
        method: 'POST',
        url: this.resourceUrl(),
        serialize: raw => raw,
        body
      }).then(this.success.bind(this), this.failure.bind(this));
    });
  }

  /**
   * Remove the image.
   */
  remove() {
    var _this$attrs$poll, _this$attrs$option;
    this.loading = true;
    m.redraw();
    let fileName = undefined;
    if (!((_this$attrs$poll = this.attrs.poll) != null && _this$attrs$poll.exists) && !((_this$attrs$option = this.attrs.option) != null && _this$attrs$option.exists)) {
      fileName = this.fileName;
    }
    app.request({
      method: 'DELETE',
      url: this.resourceUrl(fileName)
    }).then(upload => {
      var _this$attrs$poll2, _this$attrs$option2;
      if ((_this$attrs$poll2 = this.attrs.poll) != null && _this$attrs$poll2.exists) {
        this.attrs.poll.pushAttributes({
          image: null,
          imageUrl: null,
          isImageUpload: false
        });
      }
      if ((_this$attrs$option2 = this.attrs.option) != null && _this$attrs$option2.exists) {
        this.attrs.option.pushAttributes({
          imageUrl: false
        });
      }
      return upload;
    }).then(this.success.bind(this), this.failure.bind(this));
  }
  resourceUrl(fileName) {
    if (fileName === void 0) {
      fileName = undefined;
    }
    let url = app.forum.attribute('apiUrl') + '/polls/' + this.attrs.name;
    const poll = this.attrs.poll;
    const option = this.attrs.option;
    if (fileName) {
      url += '/name/' + fileName;
    } else {
      if (poll != null && poll.exists) url += '/' + (poll == null ? void 0 : poll.id());
      if (option != null && option.exists) url += '/' + (option == null ? void 0 : option.id());
    }
    return url;
  }
  getImageUrl() {
    var _this$attrs$poll3, _this$attrs$option3;
    if (this.uploadedImageUrl !== false) {
      return this.uploadedImageUrl;
    }
    return ((_this$attrs$poll3 = this.attrs.poll) == null ? void 0 : _this$attrs$poll3.imageUrl()) || ((_this$attrs$option3 = this.attrs.option) == null ? void 0 : _this$attrs$option3.imageUrl());
  }

  /**
   * After a successful upload/removal, redraw the page.
   *
   * @param {PollUploadObject} response
   * @protected
   */
  success(response) {
    var _this$attrs$onUpload, _this$attrs, _this$$input;
    this.loading = false;
    this.uploadedImageUrl = response == null ? void 0 : response.fileUrl;
    this.fileName = response == null ? void 0 : response.fileName;

    // Update the store model so other components (PollImage, PostPoll) reflect the change immediately.
    // Push the filename (not the full URL) so it matches what the API persists.
    if (response != null && response.fileName) {
      var _this$attrs$poll4, _this$attrs$option4;
      if ((_this$attrs$poll4 = this.attrs.poll) != null && _this$attrs$poll4.exists) {
        this.attrs.poll.pushAttributes({
          image: response.fileName,
          imageUrl: response.fileUrl,
          isImageUpload: true
        });
      }
      if ((_this$attrs$option4 = this.attrs.option) != null && _this$attrs$option4.exists) {
        this.attrs.option.pushAttributes({
          imageUrl: response.fileUrl,
          image_url: response.fileName,
          isImageUpload: true
        });
      }
    }
    (_this$attrs$onUpload = (_this$attrs = this.attrs).onUpload) == null || _this$attrs$onUpload.call(_this$attrs, response == null ? void 0 : response.fileName);
    m.redraw();
    (_this$$input = this.$input) == null || _this$$input.remove();
  }

  /**
   * If upload/removal fails, stop loading.
   *
   * @param {object} response
   * @protected
   */
  failure(response) {
    var _this$$input2;
    this.loading = false;
    m.redraw();
    (_this$$input2 = this.$input) == null || _this$$input2.remove();
  }
}
flarum.reg.add('fof-polls', 'forum/components/UploadPollImageButton', UploadPollImageButton);